import axios from 'axios'

export default class Mandatos {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/mandatos/dirigentesEdicao/${id}`
    this.urlEdit = `${url}/api/unimed/mandatos/dirigentes/${id}`
    this.urlCancelar = `${url}/api/unimed/mandatos/cancelarEdicao/${id}`
    this.tokenBearer = tokenBearer
  }

  async getDirigentesAdd (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getDirigentesEdit (args, idMandato) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlEdit}/${idMandato}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putDirigentes (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.urlEdit}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async delDirigentes (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: `${this.urlEdit}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigenteAdd (idDirigenteCargo) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${idDirigenteCargo}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigenteEdit (idDirigenteCargo, idMandato) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlEdit}/${idMandato}/${idDirigenteCargo}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
